<template>
  <div>
    <div v-if="users">
    <nav-bar></nav-bar>
<!--     <broadcast-messages v-if="showBroadcast" :users="usersSelected" :client="client" v-on:unselectAllUsers="unselectAllUsers"
      v-on:closeBroadcastView="closeBroadcastView" :clientName="clientName" :platform="platformUserSelected" /> -->
    <div class="container">
      <div class="section">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul v-if="client">
            <li><a>Contactos</a></li>
            <li class="is-active"><a href="#" aria-current="page">{{ clientName }}</a></li>
          </ul>
          <ul v-else>
            <li class="is-active"><a href="#" aria-current="page">{{ CONSTANTS.getCopy('USERS_BREADCRUMB') }}</a></li>
          </ul>
        </nav>
        <div class="users-filter space" v-if="users.length >= 1">
          <div class="is-flex">
            <div class="field">
              <div class="label">{{ CONSTANTS.getCopy('USERS_ORDER_BY') }}</div>
              <div class="select">
                <select v-model="orderOption" @change="changeOrder">
                  <option v-for="option in tableHeadersFiltered" :value="option.key" :key="option.key">{{ option.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="label pleft-3">{{ CONSTANTS.getCopy('USERS_TOTAL') }} {{ users.length }}<span class="phorizontal-2">-</span>{{ CONSTANTS.getCopy('USERS_FILTERS') }} {{ usersFiltered.length }}<span class="phorizontal-2">-</span>{{ CONSTANTS.getCopy('USERS_SINGLE_SELECTION') }} {{usersSelected.length}}</div>
          </div>
          <div class="button is-primary" :class="{ 'is-disabled': usersSelected.length <= 0 }"
            @click="showBroadcastModal()">
            <span class="is-capitalized">{{ idProject === '4gR073CH' ? CONSTANTS.getCopy('USERS_DOWNLOAD_MODELS') : CONSTANTS.getCopy('USERS_BROADCAST_MSG') }}</span>
          </div>
        </div>
        <div class="users-filter" v-if="users.length >= 1">
          <div class="field" v-for="(element, index) in tableHeadersFilter" :key="element.key">
            <div class="label">{{ element.name }}</div>
            <div class="control">
              <div v-if="element.typeFilter == 'COMBO'" class="select">
                <select v-model="filterOptions[index]" @change="filterUsers">
                  <option :value="null">---</option>
                  <option v-for="(el, index) in element.values" :key="index" :value="el">{{ el }}</option>
                </select>
              </div>
              <div v-else>
                <input class="input" type="date" v-model="filterOptions[index].from" @change="filterUsers" />
                <input class="input" type="date" v-model="filterOptions[index].to" @change="filterUsers" />
              </div>
            </div>
          </div>
        </div>

        <div class="field has-addons" v-if="users.length >= 1">
          <div v-if="users.length > 10000" class="control" @click="searchUsers">
            <a class="button is-primary">
              <span class="icon"><i class="fas fa-search"></i></span>
            </a>
          </div>
          <div class="control is-expanded">
            <input class="input" type="text" v-bind:placeholder="CONSTANTS.getCopy('USERS_FIND_MATCHES_PLACEHOLDER') "  v-model="textFilter"
              @keyup="() => { if (users.length < 10000) searchUsers() }" v-on:keyup.esc="textFilter = null">
          </div>
        </div>
        <div class="table" v-if="users.length >= 1">
          <table class="table is-striped is-fullwidth">
            <thead>
              <tr>
                <th>{{ CONSTANTS.getCopy('USERS_TABLE_HEADER') }}</th>
                <th v-for="header in tableHeadersFiltered" :key="header.key">{{ header.name }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(user, index) in usersFiltered" :key="index">
                <td>
                  <div class="field has-addons">
                    <p class="control">
                      <a class="button is-success" v-bind:title="CONSTANTS.getCopy('USERS_SEE_CHAT')" @click="showChatView(user.data[1])">
                        <span class="icon"><i class="fas fa-comment"></i></span>
                      </a>
                    </p>
                    <p class="control">
                      <a class="button no-border" v-if="!isSelected(user.data[2])" v-bind:title="CONSTANTS.getCopy('USERS_SELECT')"
                        @click="selectUser(user.data)">
                        <span class="icon"><i class="fas fa-check"></i></span>
                      </a>
                      <a class="button is-primary" v-else v-bind:title="CONSTANTS.getCopy('USERS_UNSELECT')" @click="unselectUser(user.data[2])">
                        <span class="icon"><i class="fas fa-check"></i></span>
                      </a>
                    </p>
                    <p class="control">
                      <a @click="deleteUser(user.data)" class="button is-danger" v-bind:title="CONSTANTS.getCopy('USERS_DELETE')">
                        <span class="icon"><i class="fas fa-trash-alt"></i></span>
                      </a>
                    </p>
                  </div>
                </td>
                <td v-for="(value, index) in user.data" v-show="tableHeaders[index].visible" :key="index">{{ value }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="is-size-2 has-text-centered">{{ CONSTANTS.getCopy('USERS_NO_ASSOCIATED_USERS') }}</div>
        <span class="show-more" v-if="usersFiltered.length >= 500 && users.length > 500 && position < users.length"
          @click="showMore">{{ CONSTANTS.getCopy('USERS_SEE_MORE') }}</span>
      </div>
    </div>
    </div>
    <div v-else>
      <nav-bar></nav-bar>
      <div class="container">
        <div class="section">
          <nav class="breadcrumb" aria-label="breadcrumbs">
            <ul v-if="client">
              <li><a>Contactos</a></li>
              <li class="is-active"><a href="#" aria-current="page">{{ clientName }}</a></li>
            </ul>
            <ul v-else>
              <li class="is-active"><a href="#" aria-current="page">{{ CONSTANTS.getCopy('USERS_BREADCRUMB') }}</a></li>
            </ul>
          </nav>
          <label class="label ptop-3">{{ CONSTANTS.getCopy('USERS_LOADING_CONTACTS') }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Arrays from '../../lib/Arrays'
import Chats from '../Chats/Chats'
import BroadcastMessages from '../dialogs/BroadcastMessages'
import Strings from '../../lib/Strings'
import CONSTANTS from '../../constants'

export default {
  components: { Chats, BroadcastMessages },
  data () {
    return {
      client: this.$route.params.client,
      clientName: 'Chatbot',
      tableHeaders: null,
      idProject: localStorage.getObject('user.idProject'),
      users: null,
      usersSelected: [],
      showBroadcast: false,
      position: 500,
      usersFiltered: [],
      platformUserSelected: null,
      textFilter: null,
      tableHeadersFiltered: [],
      orderOption: null,
      filterOptions: [],
      platforms: []
    }
  },
  computed: {
    userName () {
      return localStorage.getObject('user.name', false)
    }
  },
  created () {
    this.api.post('/DataPlatformList', { idClient: this.client }).then((response) => {
      this.platforms = response.platforms
    })
    this.getClientName()
    this.getUsers()
  },
  methods: {
    getClientName () {
      if (this.client) {
        this.api.post('/ClientById/', { idClient: this.client }).then(response => {
          this.clientName = response.client.name
        })
      }
    },
    getUsers () {
      Event.$emit('showLoading')
      this.api.post('/UsersBotGetList', { idClient: this.client }).then(response => {
        this.tableHeaders = response.headers
        this.tableHeadersFiltered = response.headers.filter(element => element.visible === 1)
        this.tableHeadersFilter = response.headers.filter(element => element.filter === 1)
        this.tableHeadersFilter.forEach((element) => {
          if (element.typeFilter === 'COMBO') {
            this.filterOptions.push(null)
            return
          }
          this.filterOptions.push({ from: null, to: null })
        })
        this.users = response.users
        this.usersFiltered = this.users.slice(0, this.position)
      })
    },
    isSelected (user) {
      return Arrays.findElement(this.usersSelected, user)
    },
    selectUser (user) {
      this.usersSelected.push([user[2], user[3]])
    },
    unselectUser (user) {
      this.usersSelected = this.usersSelected.filter(u => u[0] !== user)
    },
    unselectAllUsers () {
      this.usersSelected = []
    },
    showChatView (user) {
      if (!user) {
        this.dialog.alert({ message: CONSTANTS.getCopy('USERS_NO_CHATS') })
        return
      }
      window.open(`/#/clients/${this.client}/chats/${parseInt(user)}`, '_blank')
    },
    showBroadcastModal () {
      if (this.idProject === '4gR073CH') {
        let users = this.usersSelected.map(el => el[0])
        this.api.post('/UsersBotDownloadDocuments', { idClient: this.client, users: users }).then((response) => {
          window.open(response.rutaZip)
        })
        return
      }
      for (let i = 1; i < this.usersSelected.length; i++) {
        if (this.usersSelected[i][1] !== this.usersSelected[i - 1][1]) {
          this.dialog.alert({ message: CONSTANTS.getCopy('USERS_SELECT_SAME_PLATFORM_CONTACTS_ALERT') })
          return
        }
      }
      this.platformUserSelected = this.platforms.filter((element) => element.name.toLowerCase() === this.usersSelected[0][1].toLowerCase())[0].value
      this.dialog.userBroadcastMessages({ users: this.usersSelected, client: this.client, clientName: this.clientName, platform: this.platformUserSelected }).then(() => {
        this.unselectAllUsers()
      })
      this.showBroadcast = true
    },
    closeBroadcastView () {
      this.showBroadcast = false
    },
    showMore () {
      this.position += 500
      this.usersFiltered = this.users.slice(0, this.position)
    },
    searchUsers () {
      if (this.textFilter) {
        this.usersFiltered = this.users.filter(element =>
          element.data.filter(el =>
            el != null && Strings.normalizeText(el).search(Strings.normalizeText(this.textFilter)) > -1
          ).length > 0)
        this.usersFiltered = this.usersFiltered.slice(0, 500)
        return
      }
      this.usersFiltered = this.users.slice(0, 500)
    },
    changeOrder () {
      let index = this.tableHeaders.map(element => element.key).indexOf(this.orderOption)
      this.usersFiltered = Arrays.sortMultidimensional(this.usersFiltered, index, true)
    },
    filterUsers () {
      this.unselectAllUsers()
      this.usersFiltered = this.users
      for (let i = 0; i < this.filterOptions.length; i++) {
        let option = this.filterOptions[i]
        let index = 0
        if (option && typeof option === 'object' && (option.to && option.from)) {
          let headerKey = this.tableHeadersFilter[i].key
          index = this.tableHeaders.map(element => element.key).indexOf(headerKey)
          let dateFrom = new Date(option.from).getTime()
          let dateTo = new Date(option.to).getTime()
          this.usersFiltered = this.usersFiltered.filter(element =>
            (dateFrom < new Date(element.data[index]).getTime()) && (dateTo > new Date(element.data[index]).getTime()))
        }
        if (option && option.length > 0 && typeof option !== 'object') {
          for (let j = 0; j < this.tableHeaders.length; j++) {
            if (this.tableHeaders[j].filter === 1 && this.tableHeaders[j].values &&
              (this.tableHeaders[j].values.indexOf(option) !== -1) &&
              (this.tableHeadersFilter[i].key === this.tableHeaders[j].key)) {
              index = j
            }
          }
          this.usersFiltered = this.usersFiltered.filter(element => element.data[index] === option)
        }
      }
      if (this.orderOption !== null) {
        this.changeOrder()
      }
    },
    deleteUser (user) {
      this.dialog.confirm({ message: CONSTANTS.getCopy('USERS_DELETE_?') }).then(() => {
        this.api.post('/UsersBotDelete', { idClient: this.client, idUser: user[0], idChat: user[1] }).then(() => {
          this.getUsers()
        })
      })
    }
  }
}

</script>

<style>
.table {
  overflow-x: scroll;
  width: 100%;
}

.section .show-more {
  font-style: italic;
  margin: 20px 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
}

.is-disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.users-filter {
  display: flex;
  align-items: flex-end;
  gap: 40px;
  margin-bottom: 30px;
  overflow-x: auto;
}

.users-filter.space {
  justify-content: space-between;
}

.users-filter .field {
  margin-bottom: 0 !important;
}

.icon.custom {
  border: 1px;
}
.button.no-border {
  border: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Users.vue